export default __webpack_public_path__ + "static/media/MichaelElliEric.de29f781.jpg";